import { Controller } from "stimulus";
let medic_array = [];

export default class extends Controller {
  connect() {
    let inputs = document.getElementsByClassName("fm-input");
    getMedics();

    // Add null check and update to work with new structure
    for (let item of inputs) {
      let cohortSection = item.closest("[data-controller='cohort']");
      if (cohortSection) {
        let selector =
          cohortSection.getElementsByClassName("medic-selector")[0];
        if (selector && item.value) {
          selector.value = item.value;
        }
      }
    }
  }

  medic_select(event) {
    let element = event.target;
    let selected_id = element.options[element.selectedIndex].value;
    let medic_record = medic_array.find((medic) => medic.fm_id === selected_id);

    if (medic_record) {
      let form_group = element.closest("[data-controller='cohort']");
      if (form_group) {
        let nameInput = form_group.getElementsByClassName("name-input")[0];
        let emailInput = form_group.getElementsByClassName("email-input")[0];
        let fmInput = form_group.getElementsByClassName("fm-input")[0];

        if (nameInput) nameInput.value = medic_record.name;
        if (emailInput) emailInput.value = medic_record.email;
        if (fmInput) fmInput.value = medic_record.fm_id;
      }
    }
  }
}

const getMedics = () => {
  fetch("/get_medics")
    .then((response) => response.json())
    .then((json) => {
      medic_array = json;
    })
    .catch((error) => console.log("error", error));
};
